import { createFileRoute } from "@tanstack/react-router";
import CloseAccountPage from "@/site/pages/close-account";

// Old app's close-account / cancel flow lived at /account/cancel (?cancel=account for the
// deletion half). Reached from the Payment page + Privacy/Unsubscribe "close account" links.
export const Route = createFileRoute("/account_/cancel")({
  component: CloseAccountPage,
});
